import { render, staticRenderFns } from "./aggregations-row.vue?vue&type=template&id=0c8b90ee"
import script from "./aggregations-row.vue?vue&type=script&lang=js"
export * from "./aggregations-row.vue?vue&type=script&lang=js"
import style0 from "./aggregations-row.vue?vue&type=style&index=0&id=0c8b90ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports